<template>
  <div>
    <div style="padding: 8px; background-color: #f0f0f0; position: relative">
      <KingLongMap @LoadCompleted="MapLoadCompleted" mapId="klmap_SingleVehicleTrack" ref="map"
        style="width: 100%; height: 500px" />
      <div style="
          position: absolute;
          top: 0;
          left: 16px;
          right: 16px;
          padding: 0 8px;
        ">
        <TrackSlider v-model="current_slider" ref="trackslider" :max="totalCount" />
      </div>
    </div>
  </div>
</template>

<script>
import { getIconByDirection } from "@/utils/VehicleHelper";
import KingLongMap from "./KingLongMap";
import TrackSlider from "./TrackSlider";

export default {
  name: "SingleVehicleTrack",
  components: {
    KingLongMap,
    TrackSlider,
  },
  props: {
    vehicleInfo: {
      type: Object,
      default: {
        vehicleName: "",
        nodeValue: 0,
      },
    },
  },
  data() {
    return {
      // 页面标题
      GpsData: [], // 轨迹数据
      current_index: 0, // 当前轨迹索引

      current_slider: 0, //当前播放位置
      totalCount: 0,
      current_stop_page: 0,
      current_event_page: 0,

      current_marker: undefined,

      isMapLoaded: false,
      isDataLoaded: false,
      gpsinfo: undefined,
    };
  },
  watch: {
    current_slider() {
      this.current_index = this.current_slider;
      this.updateGpsPos();
    },
    vehicleInfo: {
      handler() {

      },
      immediate: true,
    },
  },
  //界面隐藏

  // 新增生命周期处理
  beforeDestroy() {

  },
  methods: {
    show() {
      this.isDataLoaded = false;
      //地图是否加载完成
      if (this.isMapLoaded) {
        this.isDataLoaded = true;
        this.getTrackData();
      }
    },
    destroy() {
      console.log("beforeDestroy-single");
      // 组件销毁时，停止播放轨迹
      this.$refs.trackslider.togglePlay();
      this.current_index = 0;

      this.current_play_state = false;
      console.log("sing-destroy");
      this.$refs.map.clearAll();
    },
    MapLoadCompleted() {
      console.log("MapLoadCompleted");
      //地图加载完成，去获取轨迹数据，并化线，如果没有轨迹数据，就提示当日没有轨迹
      //
      this.isMapLoaded = true;
      if (!this.isDataLoaded) {
        this.isDataLoaded = true;
        this.getTrackData();
      }
    },
    initGpsData() {
      var bd_gps = [];

      this.GpsData.forEach((item) => {
        bd_gps.push({ lng: item.Longitude, lat: item.Latitude });
      });

      this.$refs.map.addPolyline("gps_line", "gps_line", bd_gps, 5, "#2A7AFF");

      //切换轨迹点
      this.totalCount = this.GpsData.length;
      this.current_index = 0;
      this.current_slider = 0;
      this.current_page = 1;

      this.$refs.trackslider.togglePlay();

      this.current_play_state = true;
    },

    updateGpsPos() {
      //更新位置

      var _this = this;
      // console.log(_this.current_marker);

      if (_this.$refs.map) _this.$refs.map.removeMarkerById("v_last_gps");
      _this.current_marker = undefined;

      this.gpsinfo = _this.GpsData[_this.current_index];

      if (this.gpsinfo && _this.$refs.map) {
        var iconUrl = getIconByDirection(this.gpsinfo.Direction);
        _this.$refs.map.addMarker(
          "v_last_gps",
          this.vehicleInfo.vehicleName,
          this.gpsinfo.Longitude,
          this.gpsinfo.Latitude,
          iconUrl
        );

        if (_this.current_index == 0)
          _this.$refs.map.setCenter(
            this.gpsinfo.Longitude,
            this.gpsinfo.Latitude
          );
      }
    },

    getTrackData() {
      this.$api
        .QueryVehicleTrackInfo({
          VehicleId: this.vehicleInfo.nodeValue.toString(),
          // StartTime: "2025-03-13 00:00:00",
          // EndTime: "2025-03-13 20:29:39",
          StartTime: this.moment().format("YYYY-MM-DD 00:00:00"), // 动态获取当天时间
          EndTime: this.moment().format("YYYY-MM-DD 23:59:59"),
          Flag: 2,
          ParkDuration: 1,
          LanguageId: 1,
        })
        .then((res) => {
          if (
            res.code === 200 &&
            res.data &&
            res.data.GpsData &&
            res.data.GpsData.length > 0
          ) {
            //GPS数据

            this.GpsData = res.data.GpsData;
            this.$nextTick(this.initGpsData);
          } else {
            this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
          }
        })
        .catch(() => {
          this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
        });
    },
  },
};
</script>

<style scoped>
/* 设置页面标题的样式 */
h1 {
  color: #333;
}

/* 设置段落文本的样式 */
p {
  color: #666;
}
</style>
